import { cn } from '@/platform/lib/utils';
import {
    Description,
    Field,
    Checkbox as HeadlessCheckbox,
    Label,
} from '@headlessui/react';
import { CheckIcon, MinusIcon } from '@heroicons/react/16/solid';

const Checkbox = ({
    label,
    description,
    error,
    checked = false,
    indeterminate = false,
    onChange,
    required = false,
    disabled = false,
    className,
    ...props
}) => (
    <Field disabled={disabled} className={cn('block', className)}>
        <div className='inline-flex items-center gap-2 data-disabled:opacity-50'>
            <HeadlessCheckbox
                checked={checked}
                indeterminate={indeterminate}
                onChange={onChange}
                invalid={error ? true : undefined}
                className={cn(
                    'group focus-visible:outline-primary-600 flex size-4 shrink-0 cursor-pointer items-center justify-center rounded-sm outline-1 -outline-offset-1 transition focus-visible:outline-2 focus-visible:outline-offset-2 data-disabled:cursor-not-allowed',
                    error
                        ? 'outline-red-300 data-checked:bg-red-600 data-checked:outline-red-600 data-indeterminate:bg-red-600 data-indeterminate:outline-red-600'
                        : 'data-checked:bg-primary-600 data-checked:outline-primary-600 data-indeterminate:bg-primary-600 data-indeterminate:outline-primary-600 outline-gray-300'
                )}
                {...props}
            >
                {indeterminate ? (
                    <MinusIcon className='invisible size-3 text-white group-data-indeterminate:visible' />
                ) : (
                    <CheckIcon className='invisible size-3 text-white group-data-checked:visible' />
                )}
            </HeadlessCheckbox>
            {label && (
                <Label
                    as='span'
                    passive
                    className={cn(
                        'text-sm/6 font-medium text-gray-900 select-none',
                        disabled ? 'cursor-not-allowed' : 'cursor-pointer'
                    )}
                >
                    <span onClick={() => !disabled && onChange?.(!checked)}>
                        {label}
                        {required && (
                            <span className='inline-block pl-1 text-red-800'>
                                *
                            </span>
                        )}
                    </span>
                </Label>
            )}
        </div>
        {description && (
            <Description className='mt-1 text-sm/6 text-gray-500'>
                {description}
            </Description>
        )}
        {error && (
            <Description className='mt-1 text-sm text-red-600'>
                {error}
            </Description>
        )}
    </Field>
);

export default Checkbox;
